import { useMemo } from 'react'
import { Box } from '@chakra-ui/react'
import { MdArrowUpward } from 'react-icons/md'
import PropTypes from 'prop-types'

export const UiTableOrderByIcon = (props) => {
  const { isColumnOrderedBy, canColumnOrderBy, orderBy } = props
  // flip on hover for currently ordered column
  const deg = useMemo(
    () => (isColumnOrderedBy ? (orderBy?.direction === OrderByDirection.Descending ? 180 : 0) : 0),
    [isColumnOrderedBy, orderBy?.direction]
  )
  if (!canColumnOrderBy) return null

  return (
    <Box
      opacity={isColumnOrderedBy ? 1 : 0}
      _groupHover={{
        opacity: 1
      }}
      transform={`rotate(${deg}deg)`}
    >
      <MdArrowUpward
        color="inherit"
        size="14px"
      />
    </Box>
  )
}

export const OrderByDirection = {
  Ascending: 'asc',
  Descending: 'desc'
}

UiTableOrderByIcon.propTypes = {
  isColumnOrderedBy: PropTypes.bool.isRequired,
  canColumnOrderBy: PropTypes.bool.isRequired,
  orderBy: PropTypes.shape({
    key: PropTypes.string,
    direction: PropTypes.oneOf(Object.values(OrderByDirection))
  })
}
